import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.tsx";
import { lightTheme } from "./theme.ts";
import { ThemeProvider } from "@mui/styles";
import { clearLegacyAuthStorage } from "@/services/auth";

clearLegacyAuthStorage();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ThemeProvider theme={lightTheme}>
      <App />
    </ThemeProvider>
  </StrictMode>
);
